export const processingFeePercentageOfflineTxSelector = state => state?.setting?.processingFee?.percentageOfflineTx || 0;
export const processingFeeIsFetchSelector = state => state?.setting?.processingFee?.isFetch || false;